import { createContext } from 'react';
import { ThemeMode, AppTheme } from '../../styles/theme/theme.types';
import { lightColors } from '../../styles/theme/colors';

interface ThemeContextProps {
  themeMode: ThemeMode;
  isDark: boolean;
  theme: AppTheme;
  setThemeMode: (mode: ThemeMode) => void;
  toggleTheme: () => void;
}

export const ThemeContext = createContext<ThemeContextProps>({
  themeMode: 'system',
  isDark: false,
  theme: { mode: 'system', colors: lightColors },
  setThemeMode: () => {},
  toggleTheme: () => {},
});
